/** @format */
import { AxiosResponse } from 'axios';

export const isString = (value: unknown): value is string =>
    typeof value === 'string';

export const isAxiosResponse = (response: any): response is AxiosResponse =>
    Boolean(response.data);
